import React, {useEffect, useState} from 'react';
import {object, string} from "yup";
import LocationContact from "btdt/react/LocationContact";

export default function BillingStep({animating, chosenLocation, sameBilling, billingInfo, handleBillingInfoChange, handleSameBillingChange, handleFormSubmit}) {

    const [name, setName] = useState(billingInfo?.name || '');
    const [country, setCountry] = useState(billingInfo?.country || '');
    const [street, setStreet] = useState(billingInfo?.street || '');
    const [city, setCity] = useState(billingInfo?.city || '');
    const [region, setRegion] = useState(billingInfo?.region || '');
    const [postalCode, setPostalCode] = useState(billingInfo?.postalCode || '');
    const [valid, setValid] = useState(false);

    const billingSchema = object({
        name: string().required(),
        country: string().required(),
        street: string().required(),
        city: string().required(),
        region: string().required(),
        postalCode: string().required()
    });

    const validate = () => {
        const info = {name, country, street, city, region, postalCode}
        if (billingSchema.isValidSync(info)) {
            setValid(true)
            handleBillingInfoChange(info)
        }
    }

    useEffect(() => {
        validate()
    }, [name, country, street, city, region, postalCode]);

    useEffect(() => {
        handleSameBillingChange(null)
    }, [])

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <div className="large-p">
                        Is your billing information the same as the delivery information provided?
                    </div>
                </div>
                <div className={"lg:col-span-8 grid grid-cols-subgrid gap-x-8 gap-y-5 lg:col-start-3"}>
                    <div className={"lg:col-span-4 radio-option"}>
                        <input type="radio" name={"billing"} id={`billing-yes`} value={1} className={"peer"} onChange={() => handleSameBillingChange(true)}/>
                        <label htmlFor={`billing-yes`} className={"check peer-checked:bg-brand-green-light"}>
                            Yes
                        </label>
                    </div>
                    <div className={"lg:col-span-4 radio-option"}>
                        <input type="radio" name={"billing"} id={`billing-no`} value={0} className={"peer"} onChange={() => handleSameBillingChange(false)}/>
                        <label htmlFor={`billing-no`} className={"check peer-checked:bg-brand-green-light"}>
                            No
                        </label>
                    </div>
                </div>

                {sameBilling === false && (
                    <>
                        <div className={"large-p lg:col-span-8 lg:col-start-3"}>
                            Please provide the correct billing information:
                        </div>
                        <div className={"lg:col-span-4 lg:col-start-3"}>
                            <label htmlFor="contact-name" className={"form-label"}>Name</label>
                            <input type="text" id={"contact-name"} className={"form-input-text w-full bg-transparent"} value={name} onChange={e => setName(e.target.value)}/>
                        </div>
                        <div className={"lg:col-span-4"}>
                            <label htmlFor="contact-country" className={"form-label"}>Country</label>
                            <input type="text" id={"contact-country"} className={"form-input-text w-full bg-transparent"} value={country} onChange={e => setCountry(e.target.value)}/>
                        </div>
                        <div className={"lg:col-span-4 lg:col-start-3"}>
                            <label htmlFor="contact-street" className={"form-label"}>Street Address</label>
                            <input type="text" id={"contact-street"} className={"form-input-text w-full bg-transparent"} value={street} onChange={e => setStreet(e.target.value)}/>
                        </div>
                        <div className={"lg:col-span-4"}>
                            <label htmlFor="contact-city" className={"form-label"}>City</label>
                            <input type="text" id={"contact-city"} className={"form-input-text w-full bg-transparent"} value={city} onChange={e => setCity(e.target.value)}/>
                        </div>
                        <div className={"lg:col-span-4 lg:col-start-3"}>
                            <label htmlFor="contact-region" className={"form-label"}>State/Province</label>
                            <input type="text" id={"contact-region"} className={"form-input-text w-full bg-transparent"} value={region} onChange={e => setRegion(e.target.value)}/>
                        </div>
                        <div className={"lg:col-span-4"}>
                            <label htmlFor="contact-postal" className={"form-label"}>Zip/Postal Code</label>
                            <input type="text" id="contact-postal" className={"form-input-text w-full bg-transparent"} value={postalCode} onChange={e => setPostalCode(e.target.value)}/>
                        </div>
                    </>
                )}

                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <button className={"btn"} disabled={animating || sameBilling === null || (sameBilling === false && !valid)} onClick={handleFormSubmit}>
                        Submit Request
                    </button>
                </div>

                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <LocationContact location={chosenLocation}/>
                </div>
            </div>
        </div>
    )
}